export enum ENUM_HISTORY_DATE_FILTER {
  'firm_general_history_date_filter' = 'created_at',
  'firm_claims_history_date_filter' = 'order_date',
  'firm_budgets_history_date_filter' = 'created_at',
  'firm_deliverynotes_history_date_filter' = 'created_at',
  'firm_invoices_history_date_filter' = 'created_at',
  'firm_invoicesproforma_history_date_filter' = 'created_at',
  'firm_workorders_history_date_filter' = 'created_at',
}
